import {IWidgetControllerConfig} from '@wix/native-components-infra';
import {ViewerContext} from '@wix/ecom-platform-storefront-common';
import {createOOIWebBILogger} from '@wix/wixstores-client-core';

const BI_AMOUNT_MULTIPLIER = 100000;

export const toBiAmount = (amount: number) => Math.round(amount * BI_AMOUNT_MULTIPLIER);

export enum CheckoutOrigin {
  checkout = 'checkout',
  checkoutProjections = 'checkout-projections',
  paymentRequest = 'payment-request',
}

export const getUniques = (arr: string[]): string[] => {
  return [...new Set([...arr])];
};

export const createBILogger = (controllerConfig: IWidgetControllerConfig, viewerContext: ViewerContext) => {
  const bi = controllerConfig.platformAPIs.bi;
  const user = {visitor_id: bi?.visitorId};
  return createOOIWebBILogger({
    biLoggerFactory: controllerConfig.platformAPIs.biLoggerFactory!,
    user,
    biToken: bi?.biToken as string,
    defaults: {
      storeId: viewerContext.getEcomPlatformInstanceId(),
      editorMode: viewerContext.getDeviceType() === 'Desktop' ? 'desktop' : 'mobile',
      isMerchant: false,
      appName: 'Stores',
      _msid: bi?.metaSiteId,
    },
  });
};
